import React, { useState, useEffect, useRef } from 'react';
import { Box, Paper } from "@mui/material";
import eventEmitter from "../../helpers/eventEmitter";
import styles from "./DefaultModal.styles";

type ModalState = {
  isOpen: boolean;
  data: unknown[];
};

type DefaultModalChildrenArgs = {
  closeModal: () => void;
}

interface DefaultModalProps {
  children: (args: DefaultModalChildrenArgs) => React.ReactNode;
  nameEvent: string;
  onOpen: (...args: unknown[]) => void;
  modalType?: string;
  onClose?: (...args: unknown[]) => void;
}

export default function DefaultModal(
  props: DefaultModalProps) {
  const { children, nameEvent, onOpen, onClose, modalType } = props;
  const [modal, setModal] = useState<ModalState>({
    isOpen: false,
    data: [],
  });

  useEffect(() => {
    const handleOpen = (...args: unknown[]) => {
      setModal({
        isOpen: true,
        data: args,
      });
    };
    eventEmitter.on(nameEvent, handleOpen);
    return () => {
      eventEmitter.off(nameEvent, handleOpen);
    };
  }, [nameEvent]);
  const prevIsOpen = useRef(modal.isOpen);
  useEffect(() => {
    if (!prevIsOpen.current && modal.isOpen) {
      onOpen(...modal.data);
    }
    prevIsOpen.current = modal.isOpen;
  }, [modal.isOpen, modal.data, onOpen]);
  // const handleOpen = (...args: any[]) => {
  //   setModal({
  //     isOpen: true,
  //     // @ts-ignore
  //     data: args,
  //   });
  // };

  const closeModal = () => {
    onClose?.(...modal.data);
    setModal({
      isOpen: false,
      data: [],
    });
  };

  // useLayoutEffect(() => {
  //   if (modal.isOpen) onOpen(...modal.data);
  //   // if (!modal.isOpen) onClose(...modal.data);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [modal.isOpen]);

  useEffect(() => {
    if (modal.isOpen) {
      document.body.style.cssText = `overflow: hidden; padding-right: ${
        window.innerWidth - document.body.offsetWidth
      }px;`;
    } else {
      document.body.style.cssText = "";
    }
  }, [modal]);

  // useEffect(() => {
  //   eventEmitter.on(nameEvent, handleOpen);
  //   return () => {
  //     eventEmitter.off(nameEvent, handleOpen);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [nameEvent]);

  if (!modal.isOpen) return null;
  const isSearch = modalType === "search";

  return (
    <>
      <Paper
        sx={modal.isOpen ? styles.rootActive : styles.root}
      >
        <Box
          sx={
            modal.isOpen && isSearch
              ? styles.boxContentActiveSearch
              : modal.isOpen
              ? styles.boxContentActive
              : styles.boxContent
          }
        >
          {children({ closeModal })}
        </Box>
      </Paper>
    </>
  );
}
